//
//
//
//
//
//
//

export default {
    props: {
        theme: {
            type: String,
            default: 'info',
            required: false
        },
        flat: {
            type: Boolean,
            default: false,
            required: false
        },
        icon: {
            type: String,
            default: '',
            required: false
        }
    },
    computed: {
        computedIcon() {
            let response;
            if(this.icon === '') {
                if(this.theme === 'info') {
                    response = 'fas fa-info-circle';
                }
                else if(this.theme === 'success') {
                    response = 'fas fa-check';
                }
                else if(this.theme === 'warning') {
                    response = 'fas fa-exclamation-triangle';
                }
                else if(this.theme === 'danger') {
                    response = 'fas fa-engine-warning';
                }
            }
            else {
                response = this.icon;
            }
            return response;
        },
        computedClass() {
            let response;
            if(! this.flat) {
                response = this.theme+' shadow-1';
            }
            else {
                response = this.theme;
            }

            return response;
        }
    }
}
